module.exports = __webpack_public_path__ + "static/assets/5f09200519a8b4130cf1b09a35c01a10.png";